import { ZeusScalars } from '@zeus/index'

export const scalars = ZeusScalars({
  DateTime: {
    decode: (e: unknown) => new Date(e as string),
    encode: (e: unknown) => (e as Date).toISOString(),
  },
  ID: {
    decode: (e: unknown) => String(e),
    encode: (e: unknown) => String(e),
  },
})
